export default __webpack_public_path__ + "static/media/portfolio-hover-159.0938fad6.jpg";